import { Broadcast } from '@dinosband/bv-messenger-schema'
import { BvApolloClient, SmartSubscribe } from '@dinosband/bv-main-client'
import { subscribeBroadcast } from '@dinosband/bv-messenger-client'
import { BvSubscriber } from './manager/subscriber'

interface _ContextType {
  messengerClient: BvApolloClient
  chatRoomId: number
}

export class MessengerBroadcastSubscriber extends BvSubscriber<Broadcast> {

  context: _ContextType
  chatRoomId: number

  constructor (context: _ContextType, chatRoomId: number, callback: (value: Broadcast) => void) {
    super(callback as unknown as (value: Broadcast | Broadcast[]) => void)
    this.context = context
    this.chatRoomId = chatRoomId
  }

  protected async query () {
    return undefined
  }

  protected async subscribe () {
    const subscription = subscribeBroadcast(await this.context.messengerClient.getClient(), this.chatRoomId, 0).subscribe({
      next: (value) => {
        const broadcast = value.data?.broadcasted
        if (broadcast) {
          this.callback(broadcast)
        }
      },
    })
    return subscription as unknown as SmartSubscribe
  }
}
